import { createContext, useContext } from 'react';

export interface RadioGroupContextValue {
  name: string;
  value: string | undefined;
  onChange: (value: string) => void;
}

/** Provided by [[RadioGroup]]; consumed by [[Radio]] so a `value`-keyed radio
 *  reflects/sets the group selection. Null when a Radio is used standalone. */
export const RadioGroupContext = createContext<RadioGroupContextValue | null>(
  null
);

export const useRadioGroupContext = () => useContext(RadioGroupContext);
